export const PointLoyaltyPoint = (json: IPointLoyaltyPoint): IPointLoyaltyPointModel => {
	const {
		client_id,
		current_points,
		pending_points,
		loyalty_level,
		loyalty_level_id,
		updated_at,
		created_at,
		...rest
	} = json

	return {
		...rest,
		clientId: client_id,
		currentPoints: current_points,
		pendingPoints: pending_points,
		loyaltyLevel: LoyaltyLevel(loyalty_level),
		loyaltyLevelId: loyalty_level_id,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
	}
}

/**
 * Payloads
 */
export const PointLoyaltyManageToPayload = (
	event: IFormSubmitEvent<IPointLoyaltyPointForm>,
	uuid: string,
): IPointLoyaltyPointPayload => {
	const { action, points, description } = event.values

	return {
		points,
		description,
		client_uuid: uuid,
		transaction_type: action,
		loyalty_activity_id: 1,
	}
}
